import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react/dist/ssr";
import { Spinner } from "flowbite-react";
import { useOfflineAsesmenStore } from "../offline-asesmen.store";
import Layout from "../../layout.tsx/app";
import Table from "../../../components/tables/base";
import { parseDate } from "../../../helper/date";

const DetailParticipant = () => {
  const { participant, getParticipant, loadingParticipant } =
    useOfflineAsesmenStore();
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    id && getParticipant(id);
  }, [getParticipant, id]);

  return (
    <Layout withPageTitle={false}>
      <div className="py-4">
        <button
          className="flex items-center gap-3 hover:underline"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft />
          <span>Kembali</span>
        </button>
        <strong className="text-3xl block mt-4">Peserta Asesmen</strong>
      </div>
      {loadingParticipant ? (
        <div className="w-full h-[30vh] flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      ) : (
        <div className="grid md:grid-cols-3 grid-cols-1 gap-4">
          <div className="md:col-span-2">
            <strong>Bio Peserta</strong>
            <Table>
              <Table.Tr>
                <Table.Td>Nama Lengkap</Table.Td>
                <Table.Td>{participant?.name}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>NIK</Table.Td>
                <Table.Td>{participant?.nik}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Jenis Kelamin</Table.Td>
                <Table.Td className="uppercase">
                  {participant?.gender === "male" ? "Laki-laki" : "Perempuan"}
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Pendidikan</Table.Td>
                <Table.Td className="uppercase">
                  {participant?.education}
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>No Telp</Table.Td>
                <Table.Td>{participant?.phone}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Email</Table.Td>
                <Table.Td>{participant?.email ?? ""}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Role / Jabatan</Table.Td>
                <Table.Td>{participant?.role ?? ""}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Tujuan</Table.Td>
                <Table.Td>{participant?.purpose ?? ""}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Posisi saat ini</Table.Td>
                <Table.Td>{participant?.current_position ?? ""}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>Jabatan yang dituju </Table.Td>
                <Table.Td>{participant?.next_position ?? ""}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td cols={2}>
                  <>
                    Deskripsi Pekerjaan:
                    <span className="block mt-2">
                      {participant?.job_desc ?? ""}
                    </span>
                  </>
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td cols={2}>
                  <>
                    Kompetensi:
                    <span className="block mt-2">
                      {participant?.kompetensi ?? ""}
                    </span>
                  </>
                </Table.Td>
              </Table.Tr>
            </Table>
          </div>
          <div className="">
            <strong>Konfirmasi Peserta</strong>
            <div className="mt-3">
              {participant?.confirmation ? (
                <>
                  <span>
                    Sudah Konfirmasi pada:{" "}
                    {participant.confirmed_at &&
                      parseDate(participant.confirmed_at)}
                  </span>
                </>
              ) : (
                <>
                  <i>Belum konfirmasi</i>
                </>
              )}
            </div>
            <div className="mt-3">
              <span>Foto KTP</span>
              {participant?.confirmation?.foto_ktp ? (
                <img
                  src={participant?.confirmation?.foto_ktp}
                  alt=""
                  className="w-full"
                />
              ) : (
                <>
                  <small className="italic block">Belum ada foto KTP</small>
                </>
              )}
            </div>
            <div className="mt-3">
              <span>Foto Selfie</span>
              {participant?.confirmation?.foto_selfie ? (
                <img
                  src={participant?.confirmation?.foto_selfie}
                  alt=""
                  className="w-full"
                />
              ) : (
                <>
                  <small className="italic block">Belum ada foto selfie</small>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default DetailParticipant;
